import { collection, onSnapshot } from "firebase/firestore";
import { patientDirectory } from "./patientDirectory";

// Subscribe only beneath patients visible in this clinic; never query all clinics.
export function watchPatientAccounts(db, clinicId, next, error = () => {}) {
  let active = true;
  const patients = new Map();
  const emit = () => {
    if (active && [...patients.values()].every(entry => entry.ready))
      next([...patients.values()].flatMap(entry => entry.accounts));
  };
  const stopDirectory = onSnapshot(patientDirectory(db, clinicId), snapshot => {
    if (!active) return;
    const ids = new Set(snapshot.docs.map(document => document.id));
    for (const [id, entry] of patients) {
      if (!ids.has(id)) {
        entry.active = false;
        entry.stop();
        patients.delete(id);
      }
    }
    for (const id of ids) {
      if (patients.has(id)) continue;
      const entry = {active: true, ready: false, accounts: [], stop: () => {}};
      patients.set(id, entry);
      entry.stop = onSnapshot(collection(db, "clinics", clinicId, "pacientes", id, "cuentasPorCobrar"), accounts => {
        if (!active || !entry.active) return;
        entry.accounts = accounts.docs.map(document => ({...document.data(), id: document.id, pacienteId: id}));
        entry.ready = true;
        emit();
      }, caught => {
        if (active && entry.active) error(caught);
      });
    }
    emit();
  }, caught => {if (active) error(caught);});
  return () => {
    active = false;
    stopDirectory();
    for (const entry of patients.values()) {entry.active = false; entry.stop();}
    patients.clear();
  };
}
